import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch, useParams } from 'react-router-dom';
import { Permissions } from '../../app/services/Permissions';
import ViewDashBoardOutline from '../../images/material-icons/view-dashboard-outline.svg';
import InternalLink from '../../router/InternalLink';
import { RouteConstants } from '../../router/services/RouteConstants';
import LayoutActions from '../../store/layoutRedux';
import HrbTranslate from '../language/HrbTranslate';
import ToggleButton from '../library/buttons/ToggleButton';
import AssociatesIcon from '../library/graphics/AssociatesIcon';
import HrbLogoSquare from '../library/graphics/HrbLogoSquare';
import MyQueueIcon from '../library/graphics/MyQueueIcon';
import UnassignedIcon from '../library/graphics/UnassignedIcon';
import './Layout.scss';
import SideNavBasicLink from './SideNavBasicLink';
import SideNavLink from './SideNavLink';
import HelpLink from '../library/common/HelpLink';
import useNavigationHistory from '../../hooks/useNavigationHistory';

const SideNav = () => {

    const dispatch = useDispatch();

    const language = useSelector(state => state.layout.lang);
    const signedIn = useSelector(state => state.auth.signedIn);
    const employeeId = useSelector(state => state.accountData.employeeId);

    const { url } = useRouteMatch()
    const { associateId } = useParams();
    const { previousLocation, parentofPrevLocation } = useNavigationHistory();

    const isUnassignedSelected = url.toLowerCase().startsWith('/unassigned-vdo')
    const isMyQueueSelected = (
        url.toLowerCase().startsWith('/queue') ||
        (previousLocation?.pathname.toLowerCase() === '/queue' && url.includes('/reassign')) ||
        (previousLocation?.pathname.toLowerCase() === '/queue' && url.includes('/tickets')) ||
        (parentofPrevLocation?.pathname.toLowerCase() === '/queue' && previousLocation?.pathname.includes('/tickets') && url.includes('/tickets'))
    ) && (!associateId || `${associateId}` === `${employeeId}`)

    const isMyAssociatesSelected = url.toLowerCase().startsWith('/associates')
    const isHomeSelected = (!isUnassignedSelected && !isMyQueueSelected && !isMyAssociatesSelected)

    const showUnassigned = useSelector(state => (state.accountData.permissions || []).includes(Permissions.ASSIGN_TICKET))
    // only show a 'my tickets' link for DM/DoC users, as they will not have it as their home page, like support users will.
    const showMyQueueLink = useSelector(state => (state.accountData.permissions || []).includes(Permissions.VIEW_DISTRICT_OFFICES))
    const showMyAssociates = useSelector(state => (state.accountData.permissions || []).includes(Permissions.MANAGE_ASSOCIATES)
        || (state.accountData.permissions || []).includes(Permissions.MANAGE_ALL_ASSOCIATES))

    const onToggleLanguage = lang => {
        if (!Boolean(signedIn) || !employeeId) {
            dispatch(LayoutActions.setLanguage(null, lang))
        } else {
            dispatch(LayoutActions.setLanguage(employeeId, lang))
        }
    }

    return (
        <div id='sidenav'>
            <div className='top-content'>
                <div className='product-logo level columns'>
                    <div className='level-item column is-offset-2 is-3 pl-0'>
                        <InternalLink to={RouteConstants.HOME}
                            elementId='nav-link-logo' useLinkBehavior>
                            <HrbLogoSquare colour='green' />
                        </InternalLink>
                    </div>
                    <div className='product-name level-item column is-7'>
                        <div className='is-pulled-left'>
                            <HrbTranslate text='App.Name1' className='app-name1' />
                            <HrbTranslate text='App.Name2' className='app-name2' />
                        </div>
                    </div>
                </div>
                <SideNavLink to={RouteConstants.HOME} elementId='nav-button-home'
                    selected={isHomeSelected} textKey='SideNav.Home' icon={ViewDashBoardOutline} />
                {showMyQueueLink &&
                    <SideNavLink to={RouteConstants.MY_TICKET_QUEUE} elementId='nav-button-queue'
                        selected={isMyQueueSelected} textKey='SideNav.MyTickets'>
                        <MyQueueIcon />
                    </SideNavLink>
                }
                {showUnassigned &&
                    <SideNavLink to={RouteConstants.UNASSIGNED_VDO} elementId='nav-button-unassigned-vdo'
                        selected={isUnassignedSelected} textKey='SideNav.UnassignedVdo'>
                        <UnassignedIcon />
                    </SideNavLink>
                }
                {showMyAssociates &&
                    <SideNavLink to={RouteConstants.MY_ASSOCIATES_BASE} elementId='nav-button-my-associates'
                        selected={isMyAssociatesSelected} textKey='SideNav.MyAssociates'>
                        <AssociatesIcon />
                    </SideNavLink>
                }
            </div>
            <div className='bottom-content'>
                <div className='lang-btns'>
                    <ToggleButton elementId='lang-toggle' value={language || 'en'} options={['En', 'Fr']} onChange={onToggleLanguage} />
                </div>
                <div className='column is-10 is-offset-2 p-0'>
                    <HelpLink helpKey='LandingPages_Templates/ProSupport_LandingPages_Templates/ProSupportLanding_Home.htm' textKey='App.ProHelpCenterText' />
                </div>
                <SideNavBasicLink textKey='App.BlockSignal.Text' linkKey='App.BlockSignal.Link' elementId='nav-link-block-signal' />
                <SideNavBasicLink textKey='App.FeedbackSurvey.Text' linkKey='App.FeedbackSurvey.Link' elementId='nav-link-survey' />
            </div>
        </div>)
}

export default SideNav